// Προϊόντα που έχουν αποσυρθεί από τη γκάμα μας — δεν πωλούνται πλέον.
// Συγκεκριμένα: πολυσυσκευασίες εμφιαλωμένου νερού (6x1,5lt, 24x500ml, 12x500ml).
//
// Τα ps_id εδώ:
//  - εξαιρούνται από όλα τα listings/search/related/cross-sell
//  - εξαιρούνται από merchant-feed, local-inventory-feed, sitemap
//  - στη σελίδα προϊόντος: noindex, χωρίς JSON-LD, χωρίς τιμή/καλάθι, με popup
//  - block στην προσθήκη σε καλάθι/wishlist
export const DISCONTINUED_PS_IDS: ReadonlySet<number> = new Set<number>([
  112, 111, 56337, 109, 48736, 14584, 7033,
  58162, 8564, 12957, 59406, 62795, 62094, 24024,
  // Νεότερες καταχωρήσεις πολυσυσκευασιών νερού που μπήκαν στον κατάλογο
  // μετά την αρχική απόσυρση.
  70485, 70519, 70520, 70544, 70625, 70626, 70627, 70628, 71505, 48735,
]);

// Ασφαλιστική δικλείδα: κάθε νέο προϊόν νερού σε πολυσυσκευασία
// (6x1,5lt / 12x500ml / 24x500ml) μπλοκάρεται αυτόματα από το όνομά του,
// ακόμη κι αν δεν έχει προστεθεί το ps_id του παραπάνω.
const WATER_MULTIPACK_RE =
  /νερ[όο]|water/i;
const MULTIPACK_RE =
  /(^|[^\d])(6\s*[xX×]\s*1[,.]5\s*(lt|l|λτ)?|12\s*[xX×]\s*500\s*(ml)?|24\s*[xX×]\s*500\s*(ml)?|6\s*[xX×]\s*1500\s*(ml)?)/;

export function isDiscontinuedName(name: string | null | undefined): boolean {
  if (!name) return false;
  return WATER_MULTIPACK_RE.test(name) && MULTIPACK_RE.test(name);
}

export const DISCONTINUED_PS_IDS_ARRAY: readonly number[] = Array.from(
  DISCONTINUED_PS_IDS,
);

export const DISCONTINUED_TITLE = "Ουπς! Αυτό το προϊόν αποσύρθηκε 🐼";
export const DISCONTINUED_MESSAGE =
  "Δεν πωλούνται πλέον στον MrPanda προϊόντα εμφιαλωμένου νερού σε πολυσυσκευασίες 6x1,5lt, 24x500ml και 12x500ml. Ρίξε μια ματιά στα υπόλοιπα νερά μας 🌊";

export function isDiscontinued(
  psId: number | null | undefined,
  name?: string | null,
): boolean {
  if (psId != null && DISCONTINUED_PS_IDS.has(Number(psId))) return true;
  return isDiscontinuedName(name);
}

/** Τιμή έτοιμη για `.not("ps_id","in", …)` σε PostgREST. */
export const DISCONTINUED_PS_IDS_PG_LIST = `(${DISCONTINUED_PS_IDS_ARRAY.join(",")})`;